"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @function assetImport
 * @param {string} id id to import
 * @param {string} theme theme to import from
 * @description Uses require to import from assets or themes
 * @returns {string} import
 */
var assetImport = function (id, theme) {
    try {
        if (id.startsWith("theme:")) {
            return require("../../themes/".concat(theme, "/").concat(id.slice(6))).default;
        }
        return require("../../assets/".concat(id.slice(7))).default;
    }
    catch (error) {
        // console.error(`Asset import failed for ID: ${id}, Theme: ${theme}.`, error);
        return "null";
    }
};
exports.default = assetImport;
